import React, { FC, useCallback, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { Typography, FormItemProps, Tabs } from 'antd';
import { useCategoryCascaderOptions } from '@/hooks/use-category-cascader-options';
import { Gender, LabelType, availableLabelTypes } from '@/enum';
import { url } from '@/url';
import { LeftOutlined, FileExcelOutlined } from '@ant-design/icons';
import * as apiService from '@/service';
import { useAccountInfo } from '@/store/account';
import { CallNext, useFlowEffect } from '@@/react-hooks';
import { GetDesigners, GetLabelerList } from '@/service/interface';
import styles from './home.module.less';
import { homeContext } from './context';
import { ClassifyForm } from './classify-form';
import { VerifyForm } from './verify-form';

const { Title } = Typography;

const COMMON_FORM_ITEM_PROPS: FormItemProps = {
  labelAlign: 'left',
  labelCol: {
    span: 6,
  },
};

export const Home: FC = () => {
  const { userStatus, username } = useAccountInfo();

  const categoryCascaderOptionsState = useCategoryCascaderOptions();

  const genderDesignerOptionsDictState = useFlowEffect({
    [Gender.Men]: [],
    [Gender.Women]: [],
  }, function* ({ call, put }) {
    const { data }: CallNext<GetDesigners> = yield call(apiService.getDesigners);

    yield put(data);
  }, []);

  const logout = useCallback(() => {
    apiService.logout();
    location.reload();
  }, []);

  const verifiable = useMemo(() => availableLabelTypes(userStatus).includes(LabelType.Verify), [userStatus]);

  const labelerListState = useFlowEffect([] as string[], function* ({ put, call }) {
    if (verifiable) {
      const { data }: CallNext<GetLabelerList> = yield call(apiService.getLabelerList);

      yield put(data);
    }
  }, []);

  return (
    <homeContext.Provider value={{
      commonFormItemProps: COMMON_FORM_ITEM_PROPS,
      labelerListState,
      genderDesignerOptionsDictState,
      categoryCascaderOptionsState,
    }} >
      <div className={styles.home}>
        <a className={styles.logout_link} onClick={logout}>
          <LeftOutlined />
          登出账号「{username}」
        </a>
        {verifiable ? (
          <Link className={styles.export_link} to={url.report()}>
            <FileExcelOutlined /> 查看报告
          </Link>
        ) : null}
        <div className={styles.form_wrapper}>
          <Title level={2}>REVERSIBLE 标注</Title>
          {verifiable ? (
            <Tabs size="large" centered>
              <Tabs.TabPane key={LabelType.Classify} tab={<div className={styles.tab}>标注</div>}>
                <ClassifyForm />
              </Tabs.TabPane>
              <Tabs.TabPane key={LabelType.Verify} tab={<div className={styles.tab}>审核</div>}>
                <VerifyForm />
              </Tabs.TabPane>
            </Tabs>
          ) : (
            <ClassifyForm />
          )}
        </div>
      </div>
    </homeContext.Provider>
  );
};
